module.exports = __webpack_public_path__ + "static/media/website-server-hosting.33d4d010.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/website-server-hosting.jpg
// module id = 1575
// module chunks = 0